import React, { useRef, useEffect, memo, useState, useCallback, Component } from 'react';
import FlushComponent from './messaging/FlushComponent.js';
import MessageComponent from './messaging/MessageComponent.js';
import {doc} from 'effects/midi/scripting/documentation.js';
import Documented from 'components/help/Documented.js';
import DeletableEffectComponent from 'components/effects/DeletableEffectComponent.js';
import ArpEffectComponent from './ArpEffectComponent.js';
import AccumulatorComponent from './AccumulatorComponent.js';
import ControlParametersComponent from './ControlParametersComponent.js';
import PlaneParametersComponent from './plane/PlaneParametersComponent.js';
import ParameterizerEffectComponent from './ParameterizerEffectComponent.js';
import TimingEffectComponent from './TimingEffectComponent.js';
import LimitEffectComponent from './LimitEffectComponent.js';
import WarpEffectComponent from './WarpEffectComponent.js';
import TidalEffectComponent from './TidalEffectComponent.js';
import LinkedTidalComponent from './LinkedTidalComponent.js';
import MidiOutputterComponent from './MidiOutputterComponent.js';
import MidiInterfaceComponent from './MidiInterfaceComponent.js';
import HarmonyEffectComponent from './HarmonyEffectComponent.js';
import AlternateTuningEffectComponent from './AlternateTuningEffectComponent.js';
import MidiDelayEffectComponent from './MidiDelayEffectComponent.js';
import EveryEffectComponent from './EveryEffectComponent.js';
import ChordRhythmEffect from './ChordRhythmEffect.js';
import ChordSculptorEffect from './ChordSculptorEffect.js';
import MidiEffectRackComponent from './MidiEffectRackComponent.js';
import StatsComponent from './StatsComponent.js';
import ScriptComponent from './ScriptComponent.js';
import UserScriptComponent from './scripting/UserScriptComponent.js';
import GrabComponent from './GrabComponent.js';
import MicroTuningComponent from './MicroTuningComponent.js';
import NoteDisplayComponent from './NoteDisplayComponent.js';
import MidiCCEffectComponent from './MidiCCEffectComponent.js';
import ScaleEffectComponent from './ScaleEffectComponent.js';
import MidiGateEffect from './MidiGateEffect.js';
import JakiComponent from './jaki/JakiComponent.js';
import ConditionalParametersComponent from './ConditionalParametersComponent.js';
import GenerativeChordsComponent from './chords/GenerativeChordsComponent.js';
import {useConsumeWheel} from "components/hooks/useConsumeWheel.js";

const MidiEffectComponent = memo((props) => {
    let [expanded, setExpanded] = useState(false);
    let ref = useRef(undefined);
    // useConsumeWheel(ref);
    const getEffect = useCallback(() => {
        if (props.effect.name === 'Arpeggiator') {
            return (
                <ArpEffectComponent
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}/>
            );
        } else if (props.effect.name === 'Parameterizer') {
            return (
                <ParameterizerEffectComponent
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}/>
            );
        } else if (props.effect.name === 'Accumulator') {
            return (
                <AccumulatorComponent
                  isDraggable={props.isDraggable}
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}/>
            );
        } else if (props.effect.name === 'Control Parameters') {
            return (
                <ControlParametersComponent
                  isDraggable={props.isDraggable}
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}/>
            );
        } else if (props.effect.name === 'Conditional Parameters') {
            return (
                <ConditionalParametersComponent
                  isDraggable={props.isDraggable}
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}/>
            );
        } else if (props.effect.name === 'Plane Parameters') {
            return (
                <PlaneParametersComponent
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}/>
            );
        } else if (props.effect.name === 'Every') {
            return (
                <EveryEffectComponent
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}/>
            );
        } else if (props.effect.name === 'Timing') {
            return (
                <TimingEffectComponent
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}/>
            );
        } else if (props.effect.name === 'Midi Outputter') {
            return (
                <MidiOutputterComponent
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}/>
            );
            
        } else if (props.effect.name === 'Midi Interface') {
            return (
                <MidiInterfaceComponent
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}/>
            );
        } else if (props.effect.name === 'Harmony') {
            return (
                <HarmonyEffectComponent
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}/>
            );
        } else if (props.effect.name === 'Alternate Tuning') {
            return (
                <AlternateTuningEffectComponent
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}/>
            );
        } else if (props.effect.name === 'Micro Tuning') {
            return (
                <MicroTuningComponent
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}/>
            );
        } else if (props.effect.name === 'Warp') {
            return (
                <WarpEffectComponent
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}/>
            );
        } else if (props.effect.name === 'Flush') {
            return (
                <FlushComponent
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}/>
            );
        } else if (props.effect.name === 'Message') {
            return (
                <MessageComponent
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}/>
            );
        } else if (props.effect.name === 'Midi Delay') {
            return (
                <MidiDelayEffectComponent
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}/>
            );
        }  else if (props.effect.name === 'Chord Rhythm') {
            return (
                <ChordRhythmEffect
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}/>
            );
        } else if (props.effect.name === 'Chord Sculptor') {
            return (
                <ChordSculptorEffect
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}/>
            );
        } else if (props.effect.name === 'Tidal') {
            return (
                <TidalEffectComponent
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}/>
            );
        } else if (props.effect.name === 'Linked Tidal') {
            return (
                <LinkedTidalComponent
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}/>
            );
        } else if (props.effect.name === 'Scale') {
            return (
                <ScaleEffectComponent
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}/>
            );
        } else if (props.effect.name === 'Midi Effect Rack') {
            return (
                <MidiEffectRackComponent
                  isDraggable={props.isDraggable}
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}/>
            );
        } else if (props.effect.name === 'Limit') {
            return (
                <LimitEffectComponent
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}/>
            );
        }  else if (props.effect.name === 'Midi Gate') {
            return (
                <MidiGateEffect
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}/>
            );
        }  else if (props.effect.name === 'User Script') {
            return (
                <UserScriptComponent
                  isDraggable={props.isDraggable}
                  setExpanded={setExpanded}
                  expanded={expanded}
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  doc={doc}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}/>
            );
        } else if (props.effect.name === 'Midi CC') {
            return (
                <MidiCCEffectComponent
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}/>
            );
        } else if (props.effect.name === 'Note Display') {
            return (
                <NoteDisplayComponent
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}/>
            );
        } else if (props.effect.name === 'Jaki') {
            return (
                <JakiComponent
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}/>
            );
        }  else if (props.effect.name === 'Generative Chords') {
            return (
                <GenerativeChordsComponent
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}/>
            );
        } else if (props.effect.name === 'Stats') {
            return (
                <StatsComponent
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}
                  {...props}/>
            );
        } else if (props.effect.isScript) {
            return (
                <ScriptComponent
                  effectNumber={props.effectNumber}
                  sequencerEngine={props.sequencerEngine}
                  automation={props.automation}
                  selectedParameter={props.selectedParameter}
                  onEffectsChange={props.onEffectsChange}
                  onParameterChanged={props.onParameterChanged}
                  effect={props.effect}/>
            );
        }  else {
            return [];
        }
    }, [expanded, setExpanded, props.effect]);

    return (
        <Documented refObj={ref} className="midi-effect-container" element={props.effect}>
          <DeletableEffectComponent
            {... props}
            onDeleteEffect={props.onDeleteEffect}
            isMidiEffect={true}
            effectNumber={props.effectNumber}
            onToggle={() => []}
            track={props.track}
            effect={props.effect}
            automation={props.automation}>
            {getEffect()}
          </DeletableEffectComponent>
        </Documented>
    );
});

export default MidiEffectComponent;

